// @flow

import i18n from "i18next";
import k from "src/i18n/keys";
import React, { useEffect, useCallback, useRef } from "react";
import AutosizeInput from "react-input-autosize";

import { Edit as StyledEdit } from "./styles";

type Props = {
  value: any,
  handleChange: Function,
  handleSubmit: Function,
  handleKeyPress: Function,
  handleClose: Function
};

const Edit = ({
  value,
  handleSubmit,
  handleKeyPress,
  handleChange,
  handleClose
}: Props) => {
  const parentRef = useRef(null);

  const clickOutside = useCallback(
    (event: any) => {
      if (parentRef && parentRef.current) {
        if (!parentRef.current.contains(event.target)) {
          handleClose();
        }
      }
    },
    [parentRef, handleClose]
  );

  useEffect(() => {
    document.addEventListener("click", clickOutside, false);
    return () => {
      document.removeEventListener("click", clickOutside, false);
    };
  }, []);

  return (
    <StyledEdit ref={parentRef} onSubmit={handleSubmit}>
      <AutosizeInput
        type="text"
        placeholder={i18n.t(k.ENTER_CONVERSATION_TITLE)}
        onKeyDown={handleKeyPress}
        value={value}
        onChange={handleChange}
        autoFocus
      />
    </StyledEdit>
  );
};

export default Edit;
